import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  ls,
  f,
  gs,
  BtnC,
  BtnTopC,
  GridC,
  TblC,
  TextC,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as BtnTopC from "./_ccmBtnTopC";
import * as TblC from "./_ccmTblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';

import * as ica from 'src/ica';

import * as icvi10 from './icvI10___Mz';

let $i10rs = [] as ht.ls;

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  const _gUserz = gs.useUserz();
  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    if (_gUserz.crt._dmn > 0) {
      icvi10.loadI10rLsAsync({
        _31r_fst: _gUserz.crt._31rz._fst,
      })
      .then((_ls: ht.ls) => {
        $i10rs = _ls;
        _frcUdt();
      })
    }
  }, [
    _gUserz.crt._dmn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '部屋名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
  $i10rs.map( ( i10rz: ht.dz ) => {
    const _cellCs = [
      {
      boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: i10rz._icn,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: i10rz._pfx
            }
          })
        ]
      },
      {
      boxStlz: a('f/0.25'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {
            },
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  i10r_fst: i10rz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};
